(() => {
  const initReveals = () => {
    const targets = document.querySelectorAll('.nd-reveal');
    if (!targets.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      targets.forEach((target) => target.classList.add('nd-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries, instance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('nd-visible');
        instance.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    targets.forEach((target) => observer.observe(target));
  };

  const initProductGallery = () => {
    document.querySelectorAll('[data-nd-gallery]').forEach((gallery) => {
      const main = gallery.querySelector('[data-nd-main-image]');
      if (!main) return;
      gallery.querySelectorAll('[data-nd-thumb]').forEach((button) => {
        button.addEventListener('click', () => {
          const image = button.dataset.src;
          if (!image) return;
          main.src = image;
          main.alt = button.dataset.alt || '';
          gallery.querySelectorAll('[data-nd-thumb]').forEach((item) => item.setAttribute('aria-current', 'false'));
          button.setAttribute('aria-current', 'true');
        });
      });
    });
  };

  const initVariants = () => {
    document.querySelectorAll('[data-nd-product]').forEach((root) => {
      const data = root.querySelector('[data-nd-variants]');
      const form = root.querySelector('form[action*="/cart/add"]');
      if (!data || !form) return;
      let variants;
      try { variants = JSON.parse(data.textContent); } catch { return; }
      const inputs = Array.from(root.querySelectorAll('[data-nd-option]'));
      if (!inputs.length || !Array.isArray(variants)) return;
      const idInput = form.querySelector('[name="id"]');
      const price = root.querySelector('[data-nd-price]');
      const compare = root.querySelector('[data-nd-compare]');
      const button = form.querySelector('[data-nd-buy]');
      const label = button ? button.querySelector('[data-nd-buy-label]') : null;
      const originalLabel = label ? label.textContent : '';
      const currency = root.dataset.currency || 'CLP';
      const locale = document.documentElement.lang || 'es-CL';
      const formatMoney = (cents) => new Intl.NumberFormat(locale, { style: 'currency', currency, maximumFractionDigits: currency === 'CLP' ? 0 : 2 }).format(cents / 100);

      const update = () => {
        const selected = inputs.map((input) => input.value);
        const variant = variants.find((item) => item.options && item.options.every((value, index) => value === selected[index]));
        if (!variant) {
          if (idInput) idInput.disabled = true;
          if (button) button.disabled = true;
          if (label) label.textContent = 'No disponible';
          return;
        }
        if (idInput) { idInput.value = variant.id; idInput.disabled = false; }
        if (price) price.textContent = formatMoney(variant.price);
        if (compare) {
          compare.textContent = variant.compare_at_price ? formatMoney(variant.compare_at_price) : '';
          compare.hidden = !variant.compare_at_price;
        }
        if (button) button.disabled = !variant.available;
        if (label) label.textContent = variant.available ? originalLabel : 'Agotado';
      };
      inputs.forEach((input) => input.addEventListener('change', update));
    });
  };

  const init = () => { initReveals(); initProductGallery(); initVariants(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
